import { useEffect, useState } from "react";
import { useAppSelector, useIsLoggedSelector } from "../../../services/hooks.service";
import { ReactComponent as LINK } from '../../../assets/images/aff_link.svg';
import styleAf from "./Affiliate.module.scss";
import { useTranslation } from "react-i18next";
import { ROUTES, useConnectWallet } from "../../../hooks";
import { useNavigate } from "react-router-dom";
import BigNumber from "bignumber.js";
import { errorHandler } from "../../../_utils/errorHandlers";
import { LogIn } from "../../common/Header/LogIn/LogIn";
import { convertFeeToPrecent } from "../../../_utils";

interface Props {
  setAffiliate: (a) => void
}

export const AffiliateConnection = ({ setAffiliate }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isLogged = useIsLoggedSelector();
  const { connectWallet, connectWalletModal } = useConnectWallet();

  const isAffiliate = useAppSelector((state) => state.user.isAffiliate);
  const sdkClient = useAppSelector((state) => state.sdkClient.instance);
  const mainAddress = useAppSelector((state) => state.user.mainAddress);
  const activeAddress = useAppSelector((state) => state.user.activeAddress);
  const unlockUSDC = useAppSelector((state) => state.settings.affiliateDashboardThreshold);
  const feeShare = useAppSelector((state) => state.settings.affiliateDefaultFeeShare);
  const appTitle = useAppSelector((state) => state.settings.appTitle);
  const [userUSDC, setUserUSDC] = useState(0);
  const [width, setWidth] = useState(0);

  const handleButton = () => {
    if (!isLogged) {
      connectWallet();
    } else {
      BigNumber(width).isGreaterThanOrEqualTo(100)
        ? setAffiliate(true)
        : navigate(ROUTES.trade);
    }
  }

  useEffect(() => {
    if (isAffiliate === false && sdkClient.companyId) {
      sdkClient.getAffiliateProgress(sdkClient.companyId)
      .then((res: {totalTradingVolumeUsd: number, unlockThreshold: number}) => {
        const percent = Number(res.unlockThreshold) 
          ? BigNumber(res.totalTradingVolumeUsd).multipliedBy(100).dividedBy(unlockUSDC)
          : 100;
        setWidth(Number(percent));
        setUserUSDC(res.totalTradingVolumeUsd);
      })
      .catch(e => errorHandler(e))
    }
  }, [isAffiliate, sdkClient]);

  return (
    <div className={styleAf.connect_wrapper}>
      <h4>{ t("affiliates.affiliate_txt") }</h4>

      <div className={styleAf.cont}>
        <div className={styleAf.cont_header}>
          <LINK />
          { t("affiliates.unlock_referral_link") }
        </div>
        <div className={styleAf.cont_body}>
          { !mainAddress && <p>{ t("affiliates.earn_more", { name: appTitle }) }</p> }
          { mainAddress && Number(feeShare) > 0 && <p>{ t("affiliates.why_referrer") }</p> }
          <ul>
            { Number(feeShare) > 0 && <li>{ t("affiliates.earn_every_user", { fee: convertFeeToPrecent(feeShare) }) }</li> }
            { Number(unlockUSDC) > 0 && <li>{ mainAddress ? t("affiliates.earn_whenever") : t("affiliates.start_trading", { vol: unlockUSDC }) }</li> }
          </ul>
          { mainAddress && Number(unlockUSDC) > 0 &&
            <div className={styleAf.proggres_cont}>
              <p>{ t("affiliates.progress_tracker") }</p>
              <div className={styleAf.proggres_scale}>
                <span style={{width: `${width}%`}} className={styleAf.scale_perc} />
              </div>
              <p>
                <span className={styleAf.big_txt}>${userUSDC}</span>
                <span className={styleAf.big_txt} style={{fontWeight: 400}}>/{`$${unlockUSDC}`}</span>
                <span className={styleAf.gray_txt}>{ t("affiliates.trading_volume") }</span>
              </p>
            </div>
          }
          { (activeAddress && !isLogged) 
            ? <LogIn /> 
            : <button className="main_btn" onClick={handleButton}>
              { !mainAddress 
                ? t("affiliates.connect_to_started") 
                : BigNumber(width).isGreaterThanOrEqualTo(100) 
                  ? t("affiliates.create_link_now") 
                  : t("affiliates.trade_now") 
              }
            </button>
          }
        </div>
      </div>
      
      { connectWalletModal() }
    </div>
  )
}
